import cx from 'classnames';

interface Props {
  children: React.ReactNode;
}

export default function RecommendationsList({ children }: Props) {
  return <ul className={cx('flex flex-col gap-4')}>{children}</ul>;
}
